import { encode, decode } from "helpers/secrets"

class LocalStore { }

LocalStore.set = (key, data) => {
  var data = {
    data: data,
  }
  localStorage.setItem(key, JSON.stringify(data))
}

LocalStore.get = (key) => {
  let data = localStorage.getItem(key)
  var cData = null
  if (data && data !== "null" && data !== undefined) {
    cData = JSON.parse(data)
  }
  return cData
}

export default LocalStore
